import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SettingsState {
  activeId: string;
}

const initialState: SettingsState = {
  activeId: "org_info",
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setActiveSettingsId(state, action: PayloadAction<string>) {
      state.activeId = action.payload;
    },
  },
});

export const { setActiveSettingsId } = settingsSlice.actions;
export default settingsSlice.reducer;
